module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/car4.webp";